export default "<tabbed-modal-tab tab=\"$ctrl.tab\">\r\n\t<p>Products management is not currently implemented</p>\r\n</tabbed-modal-tab>\r\n";